import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'mg-points-manager',
  templateUrl: './points-manager.component.html',
  styleUrls: ['./points-manager.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PointsManagerComponent {
  constructor() {}
}
